// Nur-Lese-Abfragen für die Übersicht der Hausmeister-App (Portale-Redesign E2).
// Alles mit den Rechten des Hausmeisters: die RLS liefert nur freigegebene Tickets
// (ticket_freigegeben) bzw. eigene Fahrten – hier wird nichts geschrieben.
import { supabase } from '../supabase/client';

export interface Abnahme { id: string; name: string; funktion: string; created_at: string }

/** Abnahmen eines Auftrags – dieselbe Abfrage, die bisher direkt in der Detailansicht stand. */
export async function ladeAbnahmen(ticketId: string): Promise<Abnahme[]> {
  const { data, error } = await supabase
    .from('ticket_abnahmen').select('id, name, funktion, created_at')
    .eq('ticket_id', ticketId).order('created_at', { ascending: false });
  if (error) { console.error('Abnahmen laden fehlgeschlagen', error.message); return []; }
  return (data || []) as Abnahme[];
}

/** Selbst erfasste Material-Positionen über alle freigegebenen Aufträge. */
export async function ladeEigenesMaterial(meineId: string): Promise<{ menge: number; einzelpreis: number | null }[]> {
  const { data, error } = await supabase
    .from('ticket_material').select('menge, einzelpreis').eq('erfasst_von', meineId);
  if (error) { console.error('Material (Übersicht) laden fehlgeschlagen', error.message); return []; }
  return (data || []) as { menge: number; einzelpreis: number | null }[];
}

/** Anzahl der selbst eingeholten Abnahmen über alle freigegebenen Aufträge. */
export async function zaehleEigeneAbnahmen(meineId: string): Promise<number> {
  const { count, error } = await supabase
    .from('ticket_abnahmen').select('id', { count: 'exact', head: true }).eq('erfasst_von', meineId);
  if (error) { console.error('Abnahmen (Übersicht) zählen fehlgeschlagen', error.message); return 0; }
  return count ?? 0;
}

export interface LetzteNotiz { id: string; ticket_id: string; inhalt: string; created_at: string }

/** Die neuesten sichtbaren Notizen über alle freigegebenen Aufträge. */
export async function ladeLetzteNotizen(anzahl = 3): Promise<LetzteNotiz[]> {
  const { data, error } = await supabase
    .from('ticket_kommentare').select('id, ticket_id, inhalt, created_at')
    .order('created_at', { ascending: false }).limit(anzahl);
  if (error) { console.error('Letzte Notizen laden fehlgeschlagen', error.message); return []; }
  return (data || []) as LetzteNotiz[];
}
